// test1739
(1739 && 0);
